/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Turn_OnInputs */

const vi_irrigation_pump_turn_on = /** @type {(inputs: Irrigation_Pump_Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật`)
};

/**

* @param {Irrigation_Pump_Turn_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_turn_on = /** @type {((inputs?: Irrigation_Pump_Turn_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Turn_OnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_turn_on(inputs)
});